// === IMPORT STYLE CSS / SCSS ===
import '@csstools/normalize.css';
import '../scss/main.scss';

// === IMPORT JS ===
import { initLenis } from './libs/scrollLenis';
import NavHeight from './utils/nav-height';
import Nav from './layouts/nav';
import NavResponsive from './layouts/nav-responsive';
import VideoPlayers from './libs/videoPlayers';
import SwiperSliders from './libs/swiper';
import NumbersAnimations from './layouts/numbers-animations';
import SwitchTabs from './layouts/switch-tabs';
import Accordions from './layouts/accordions';
import Ajax from './layouts/ajax';
import { btnArrowOnHover } from "./utils/btnArrowAnimations";
// Spline : import dynamique (voir DOMContentLoaded)
import { initTeamMarquee } from './layouts/teamMarquee';
// import PartnersMarquee from './layouts/partnersMarquee';
import HorizontalMarquee from './layouts/horizontalMarquee';
import Selects from './libs/selects';
import initLangSelect from './utils/lang-select';

const initScripts = () => {
    try {
        const opts = window.siteOptions || {};
        const nav = new Nav(opts);

        if( opts.enableSmoothScroll ) {
            initLenis((e) => nav.onScroll(e));
        } else {
            let ticking = false;
            let lastY = window.scrollY;
            const run = () => {
                const y = window.scrollY;
                const dir = y >= lastY ? 1 : -1;
                nav.onScroll({ scroll: y, velocity: 0, direction: dir });
                lastY = y;
                ticking = false;
            };
            window.addEventListener('scroll', () => {
                if (!ticking) {
                    requestAnimationFrame(run);
                    ticking = true;
                }
            }, { passive: true });
        }

        new NavHeight();
        new NavResponsive();
        new SwiperSliders();
        new VideoPlayers();
        new NumbersAnimations();
        new SwitchTabs();
        new Accordions();
        new Ajax();
        // new PartnersMarquee();
        initTeamMarquee();
        new Selects('.js-select');
        initLangSelect();

        new HorizontalMarquee({
            // 1) Supporte tes marquees legacy existants (ex: .marquee.marqueePartners-2)
            marqueeSelector: '.marquee',

            // 2) Hydrate aussi le block Team (utilise .grid_content comme source)
            sectionSelectors: ['.block-team-marquee-actifdigital'],
            sectionTrackSel: '.grid_content',
            speed: 70,
            direction: 1,
            alternateDirections: false,
            minFillFactor: 2.3,
            pauseOnHover: true,
        });

        document.querySelectorAll('.btn.has-icon--right').forEach(icon =>
            btnArrowOnHover(icon, 'right')
        );
        document.querySelectorAll('.btn.has-icon--left').forEach(icon =>
            btnArrowOnHover(icon, 'left')
        );
        document.querySelectorAll('.swiper-navigation .swiper-next').forEach(next =>
            btnArrowOnHover(next, 'right')
        );
        document.querySelectorAll('.swiper-navigation .swiper-prev').forEach(prev =>
            btnArrowOnHover(prev, 'left')
        );

    } catch (error) {
        console.error("Erreur lors de l'initialisation des scripts :", error);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initScripts();

    // Spline : chargé uniquement si #spline-hero est dans le DOM
    // (évite de télécharger ~3 Mo de JS quand l'image ACF est utilisée)
    const splineEl = document.querySelector('#spline-hero');
    if (splineEl) {
        import('./spline/splineLock').then(({ initSplineLock }) => {
            const spline = initSplineLock(splineEl);
            if (spline) window.toggleSplineLock = spline.toggle;
        });
    }
});